export default __webpack_public_path__ + "static/media/photo.89061349.svg";